import { Card, Chip, CardContent, Divider, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { formatPhone } from "../../functions/misc";
import { User } from "@phosphor-icons/react";
import { motion } from "framer-motion";

type Props = {
    profileData: any
    subscriptionInfo: any
}
const BasicInformation = ({ profileData, subscriptionInfo }: Props) => {

    return (
        <Card sx={{ borderRadius: 1 }}>
            <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
                <Typography variant="subtitle1" sx={{ m: 2, mb: 3 }}>
                    <User className="me-2" />
                    {profileData && profileData.lead && profileData.lead.LeadStatus === 'Inactive' ?
                        <motion.span className={'badge-inactive'} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                            {'Inactive'}
                        </motion.span>
                        :
                        <Chip icon={<CheckCircle style={{ fill: '#15B79F' }} />} label={'Active'} variant="outlined" size="small"></Chip>
                    }
                </Typography>
                {/* 
                <div className="row">
                    <div className="col-md-8">
                        <Typography variant="subtitle1" sx={{ m: 2, mb: 3 }}>
                            <User className="me-2" />
                            {'Basic Details'}
                        </Typography>
                    </div>
                    <div className="col-md-4" style={{paddingTop: "16px"}}>
                        {profileData && profileData.lead && profileData.lead.LeadStatus === 'Inactive' ?
                            <motion.span className={'badge-inactive'} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                                {'Inactive'}
                            </motion.span>
                            :
                            <Chip icon={<CheckCircle style={{ fill: '#15B79F' }} />} label={'Active'} variant="outlined" size="small"></Chip>
                        }
                    </div>
                </div> */}
                <Typography variant="body2" sx={{ mx: 2, mt: 1, color: '#667085' }}>
                    {'Name'}
                </Typography>
                <Typography variant="body1" sx={{ mx: 2, mb: 1 }}>
                    {profileData?.FirstName + " " + profileData?.LastName}
                </Typography>
                <Divider />
                <Typography variant="body2" sx={{ mx: 2, mt: 1, color: '#667085' }}>
                    {'Email'}
                </Typography>
                <Typography variant="body1" sx={{ mx: 2, mb: 1 }}>
                    {profileData?.Email}
                </Typography>
                <Divider />
                <Typography variant="body2" sx={{ mx: 2, mt: 1, color: '#667085' }}>
                    {'Phone'}
                </Typography>
                <Typography variant="body1" sx={{ mx: 2, mb: 1 }} >{profileData?.Phone ? formatPhone(profileData?.Phone) : ''}

                </Typography>
                <Divider />
                {subscriptionInfo &&
                    <>
                        <Typography variant="body2" sx={{ mx: 2, mt: 1, color: '#667085' }} >{'Subscription Type'}

                        </Typography>
                        <Typography variant="body1" sx={{ mx: 2, mb: 1 }} >{subscriptionInfo?.ProtectionPlanName}

                        </Typography>
                        <Divider />
                    </>}
            </CardContent>
        </Card>
    );
}

export default BasicInformation;